import React from 'react';
import './BackgroundGradients.css';

const BackgroundGradients = () => {
  return (
    <>
      <div className="bg-gradient bg-gradient-1"></div>
      <div className="bg-gradient bg-gradient-2"></div>
      <div className="bg-gradient bg-gradient-3"></div>
    </>
  );
};

export default BackgroundGradients;
